import { render, staticRenderFns } from "./cctvDocUpload.vue?vue&type=template&id=1ce27f52&scoped=true"
import script from "./cctvDocUpload.vue?vue&type=script&lang=js"
export * from "./cctvDocUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce27f52",
  null
  
)

export default component.exports